import React, { useState, useEffect } from 'react';
import { DashboardLayout } from '@blumtechgroup/blum-react-core-components';
import { StringUtils } from '@blumtechgroup/blum-ui-utils';
import { useParams, useNavigate } from 'react-router-dom';
import { useQuery } from '@apollo/client';
import { Clinician, editClinicianUserInitQuery } from './queries';
import { EditClinicianUsersComponent } from '../../../../components/Global';

type UrlParams = {
  clinician_id: string;
};

const EditClinicianUsers = (): React.ReactElement => {
  const navigate = useNavigate();

  const { clinician_id } = useParams<UrlParams>();

  const [clinician, setClinician] = useState<Clinician>({
    first_name: '',
    last_name: '',
  });

  const { data: editClinicianUserInitData } = useQuery(editClinicianUserInitQuery(clinician_id!), { fetchPolicy: 'no-cache' });

  useEffect(() => {
    if (editClinicianUserInitData) {
      const { users_clinician_by_pk } = editClinicianUserInitData;
      setClinician(users_clinician_by_pk);
    }
  }, [editClinicianUserInitData]);

  const handleFinish = () => {
    navigate(`/loc/clinicians/${clinician_id}`);
  };

  return (
    <DashboardLayout
      breadcrumbs={[
        { label: 'Home', link: '/loc/home' },
        { label: 'Clinicians', link: `/loc/clinicians` },
        {
          label: StringUtils.stringFromArray([clinician.first_name, clinician.last_name]),
          link: `/loc/clinicians/${clinician_id}`,
        },
        { label: 'Edit' },
      ]}>
      <EditClinicianUsersComponent clinicianId={clinician_id!} handleFinish={handleFinish} />
    </DashboardLayout>
  );
};

export default EditClinicianUsers;
